// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1fZeA","productName":"Table_productName__RgOzy"};